import { configureStore } from "@reduxjs/toolkit";
import counterReducer, {
  pageLevelRestrictionSlice,
  handleTabValuesSlice,
  SettingsSlice,
  IdentifyLeakerSlice,
  timeZoneSlice,
  idLeakersSlice,
  DocumentTemplatesSlice,
  DocumentTemplateNameSlice,
  CustomFilterOptionsSlice,
  TemplateIdentifyLeakerSlice
} from "./actions";
import formChangesReducer from "./formChanges-slice";


export default configureStore({
  reducer: {
    counter: counterReducer,
    pageLevelRestriction: pageLevelRestrictionSlice.reducer,
    timeZone: timeZoneSlice.reducer,
    hanldeValues: handleTabValuesSlice.reducer,
    settings:SettingsSlice.reducer,
    identifyLeakers:IdentifyLeakerSlice.reducer,
    formChanges: formChangesReducer,
    idLeakers:idLeakersSlice.reducer,
    documentTemplates:DocumentTemplatesSlice.reducer,
    documentTemplateName:DocumentTemplateNameSlice.reducer,
    customFilterOptions:CustomFilterOptionsSlice.reducer,
    templateIdentifyLeakers: TemplateIdentifyLeakerSlice.reducer
  },
});
